import { useQuery } from '@tanstack/react-query';
import { useOrganization } from '@/domains/organizations';
import { brandRepository } from '../repositories/brand.repository';
import { brandKeys } from '../services/brand.keys';

export function useDashboardBrands() {
  const { currentOrganization } = useOrganization();
  const orgId = currentOrganization?.id;

  return useQuery({
    queryKey: brandKeys.dashboard(orgId),
    queryFn: async (): Promise<number> => {
      return brandRepository.getDashboardBrandCount(orgId);
    },
    enabled: !!orgId,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
